import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function ForWhomSection() {
  return <Section bg="cream" data-id="element-69">
      <div className="grid md:grid-cols-2 gap-8" data-id="element-70">
        {/* Who it is for */}
        <div className="bg-white p-8 rounded-3xl shadow-lg border-t-4 border-[#EA580C]" data-id="element-71">
          <h3 className="text-2xl font-bold text-[#422006] mb-6 flex items-center gap-2" data-id="element-72">
            ✅ Esto SÍ es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-73">
            <li className="flex gap-3" data-id="element-74">
              <Check className="text-[#EA580C] shrink-0 mt-1" size={20} data-id="element-75" />
              <span className="text-[#78350F]" data-id="element-76">
                Eres una mamá soltera que trabaja jornada completa y llega a
                casa al límite de su capacidad mental.
              </span>
            </li>
            <li className="flex gap-3" data-id="element-77">
              <Check className="text-[#EA580C] shrink-0 mt-1" size={20} data-id="element-78" />
              <span className="text-[#78350F]" data-id="element-79">
                Sientes culpa por darles comida procesada o nuggets congelados a
                tus hijos por falta de tiempo.
              </span>
            </li>
            <li className="flex gap-3" data-id="element-80">
              <Check className="text-[#EA580C] shrink-0 mt-1" size={20} data-id="element-81" />
              <span className="text-[#78350F]" data-id="element-82">
                Odias lavar platos y buscas ensuciar lo mínimo indispensable
                cada noche.
              </span>
            </li>
            <li className="flex gap-3" data-id="element-83">
              <Check className="text-[#EA580C] shrink-0 mt-1" size={20} data-id="element-84" />
              <span className="text-[#78350F]" data-id="element-85">
                Quieres recuperar al menos 20 minutos de paz cada tarde para ti
                misma.
              </span>
            </li>
          </ul>
        </div>

        {/* Who it is NOT for */}
        <div className="bg-white/50 p-8 rounded-3xl border border-[#78350F]/10" data-id="element-86">
          <h3 className="text-2xl font-bold text-[#78350F] mb-6 flex items-center gap-2 opacity-80" data-id="element-87">
            ❌ Esto NO es para ti si...
          </h3>
          <ul className="space-y-4 opacity-80" data-id="element-88">
            <li className="flex gap-3" data-id="element-89">
              <X className="text-[#78350F] shrink-0 mt-1" size={20} data-id="element-90" />
              <span className="text-[#78350F]" data-id="element-91">
                Disfrutas pasar 2 horas picando vegetales y siguiendo recetas de
                20 pasos.
              </span>
            </li>
            <li className="flex gap-3" data-id="element-92">
              <X className="text-[#78350F] shrink-0 mt-1" size={20} data-id="element-93" />
              <span className="text-[#78350F]" data-id="element-94">
                No estás dispuesta a dedicar 20 minutos un domingo a preparar tu
                base maestra.
              </span>
            </li>
            <li className="flex gap-3" data-id="element-95">
              <X className="text-[#78350F] shrink-0 mt-1" size={20} data-id="element-96" />
              <span className="text-[#78350F]" data-id="element-97">
                Eres un chef que busca cocina de autor; esto es cocina de
                "supervivencia" y eficiencia real.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </Section>;
}